import { useTranslation } from "react-i18next";

import { Table } from "@mantine/core";

import { useFormatters } from "@prostocheck/i18n";
import { Badge } from "@prostocheck/ui";

import { IReceiptSummaryProps } from "./receipt-summary.models";

/**
 * The fiscal identity of the document: the two ФН, the tax, and whether ДПС
 * has it at all — an offline receipt is valid, it simply has not arrived yet.
 */
export const ReceiptSummary = ({ receipt }: IReceiptSummaryProps) => {
  const { t } = useTranslation();
  const { formatPrice } = useFormatters();

  return (
    <Table variant="vertical" mt="lg" withTableBorder={false}>
      <Table.Tbody>
        <Table.Tr>
          <Table.Th c="dimmed" fw={400}>
            {t("receipt.receiptFiscalNumber")}
          </Table.Th>
          <Table.Td ta="right" fw={500}>
            {receipt.fiscalNumber}
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th c="dimmed" fw={400}>
            {t("receipt.registerFiscalNumber")}
          </Table.Th>
          <Table.Td ta="right" fw={500}>
            {receipt.cashRegisterFn}
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th c="dimmed" fw={400}>
            {t("receipt.vat")}
          </Table.Th>
          <Table.Td ta="right" fw={500}>
            {formatPrice(receipt.vatTotal)}
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th c="dimmed" fw={400}>
            {t("receipt.status")}
          </Table.Th>
          <Table.Td ta="right">
            {receipt.isOffline ? (
              <Badge tone="warning">{t("receipt.statusOffline")}</Badge>
            ) : (
              <Badge tone="success">{t("receipt.statusAccepted")}</Badge>
            )}
          </Table.Td>
        </Table.Tr>
      </Table.Tbody>
    </Table>
  );
};
